import ImmutablePropTypes from "react-immutable-proptypes";
import React from "react";

const ValidClubList = ({ productBehavior, translate, excludedClubs }) =>
  productBehavior.getIn(["configuration", "clubsIncluded"]) &&
  productBehavior.getIn(["configuration", "clubsIncluded"]).size ? (
    <div>
      {productBehavior
        .getIn(["configuration", "clubsIncluded"])
        .map(club => <div key={club.get("@id")}>{club.get("name")}</div>)}
    </div>
  ) : (
    <div>
      {translate("Pour tous les golfs")}
      {excludedClubs.size ? (
        <p>
          <span>{translate("Excepté")} :</span>
          {excludedClubs.map(club => <div key={club.get("@id")}>{club.get("name")}</div>)}
        </p>
      ) : null}
    </div>
  );

ValidClubList.propTypes = {
  productBehavior: ImmutablePropTypes.map.isRequired,
  excludedClubs: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired
};

export default ValidClubList;



// WEBPACK FOOTER //
// ./src/app/components/ProductPage/ValidClubList/ValidClubList.js